import React, { useEffect, useContext } from 'react';
import { Context as MediaContext } from './context/MediaContext';
import MediaCard from './components/MediaCard';
import { ReactComponent as TMDBLogo } from './images/tmdb.svg';
import './App.css';

const App = () => {
  const {
    state,
    fetchMovies,
    fetchTvShows,
    fetchMovieGenres,
    fetchTvShowGenres,
  } = useContext(MediaContext);

  useEffect(() => {
    fetchMovies();
    fetchMovieGenres();
    fetchTvShows();
    fetchTvShowGenres();
  }, []);

  return (
    <div className="App">
      {state.errors && (
        <div className="errors">
          {state.errors.map((error) => (
            <>
              <p>Type: {error.type}</p>
              <p>Message: {error.message}</p>
            </>
          ))}
        </div>
      )}
      <div className="content-container">
        <div className="tv-show-content">
          <div className="header-tv-shows">
            <TMDBLogo className="logo" />
            <h1>Trending TV Shows</h1>
          </div>
          <div className="cards">
            {state.tvShows.map((tvShow) => (
              <MediaCard key={tvShow.id} media={tvShow} type="tv" />
            ))}
          </div>
        </div>
        <div className="movie-content">
          <div className="header-movies">
            <h1>Trending Movies</h1>
          </div>
          <div className="cards">
            {state.movies.map((movie) => (
              <MediaCard key={movie.id} media={movie} type="movie" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
